import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet"

 

import { InquiryForm } from "./components/"

class GettingStarted extends Component{
  submit = (values) => {
    // print the form values to the console

    // console.log(values)

    const formUri = `https://afrodesiamedia.com/admin/api/forms/submit/gettingstarted?token=7289370ee7736e97be508a8fba6003`

    const apiUri = `https://afrodesiamedia.com/admin/api/collections/save/getting?token=7289370ee7736e97be508a8fba6003`

    fetch( apiUri , {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
           data: values,
        })  
    })
    .then(collection => collection.json())
    // .then(collection => console.log(collection));
    // this.props.history.push('/inquiry-submition')
    // localStorage.setItem('values', values);

    fetch(formUri, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
          form: values
      })
  })
  .then(entry => entry.json())
  // .then(entry => console.log(entry));
  this.props.history.push('/inquiry-submition')
  localStorage.setItem({form: values});
    // console.log(values)
  }

  render(){
    return(
       <Fragment>
        <Helmet>
          <title> Getting Started - afrodesiamedia </title>
          <link rel="shortcut icon" href="/favicon.ico"/>
          <meta property="og:title" content="Getting Started" />
        </Helmet>
        <section className="GettingStarted">
        <header className="heading">
          <h1>Getting Started</h1>
        </header>
        <InquiryForm onSubmit={this.submit} />
         </section>
      </Fragment>
    )
  }
}
export default GettingStarted



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/GettingStarted/GettingStarted.js